import { useMediaQuery, useTheme } from "@mui/material";

export const useDeviceType = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(min-width: 360px) and (max-width: 599px)");
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const isPc = useMediaQuery(theme.breakpoints.up("lg"));

  if (isMobile) return "mobile";
  if (isTablet) return "tablet";
  return "pc";
};
